<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { onBeforeMount, reactive, ref, toRefs } from "vue";
import Button from "../../../base-components/Button";
import { FormInput, FormLabel } from "../../../base-components/Form";
import LoadingIcon from "../../../base-components/LoadingIcon";
import Preview from "../../../base-components/Preview";
import { userUserStore } from "../../../stores/user";

import OpcionesGeneralesGetnetPos from "./OpcionesGeneralesGetnetPos.vue";
import { IGetnetPOSConfig, IGetnetConfig } from "@fixeduy/restaurantestypes";

const userStore = userUserStore();
// const localesStore = useLocalesStore();

const emit = defineEmits<{ (e: "cerrar"): void }>();

const cargando = ref<boolean>(false);

const formData = reactive({
  EmpHASH: userStore.opcionesGenerales.integracionPOSGetnet?.EmpHASH,
  EmpCod: userStore.opcionesGenerales.integracionPOSGetnet.EmpCod,
  integracionGetnetPOS: userStore.opcionesGenerales.integracionPOSGetnet.pos
});

const rules = {
  EmpHASH: {
    required: helpers.withMessage(
      "El campo HASH no puede estar vacío",
      required
    )
  },
  EmpCod: {
    required: helpers.withMessage(
      "El campo CÓDIGO no puede estar vacío",
      required
    )
  },
  integracionGetnetPOS: {
    required: helpers.withMessage("Debes cargar al menos un pos", required)
  }
};

const validate = useVuelidate(rules, toRefs(formData));

const agregarPosVacio = () => {
  formData.integracionGetnetPOS.push({
    nombre: "",
    local: "",
    TermCod: "",
    imprime: true
  });
};

onBeforeMount(() => {
  if (formData.integracionGetnetPOS.length == 0) {
    agregarPosVacio();
  }
});

const actualizarPOS = (params: { indice: number; pos: IGetnetPOSConfig }) => {
  formData.integracionGetnetPOS[params.indice] = params.pos;
};

const handlerGuardar = async () => {
  const result = await validate.value.$validate();
  if (result) {
    const config: IGetnetConfig = {
      EmpHASH: formData.EmpHASH,
      EmpCod: formData.EmpCod,
      habilitado: userStore.opcionesGenerales.integracionPOSGetnet.habilitado,
      pos: formData.integracionGetnetPOS
    };
    userStore.setOpcionesGetnet(config);
    cargando.value = false;
    emit("cerrar");
  }
};
</script>

<template>
  <Preview class="box mt-5">
    <form class="validate-form p-4" @submit.prevent="">
      <div
        class="border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400"
      >
        <div
          class="w-full pb-6 cursor-pointer flex-row flex"
          @click="
            () => {
              emit('cerrar');
            }
          "
        >
          <div class="flex w-full justify-center mt-2">
            <h1 class="self-center text-xl mt-2">Opciones Getnet</h1>
          </div>
        </div>

        <!-- EMPHASH  -->
        <div class="col-span-12 lg:col-span-6 mt-3 mb-5">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel htmlFor="horizontal-form-1" class="w-40 sw:w-20"
                >HASH (brindado por Getnet)</FormLabel
              >
            </div>
            <div>
              <FormInput
                type="text"
                v-model.trim="formData.EmpHASH"
                placeholder="HASH"
              />
            </div>
          </div>
        </div>

        <!-- EMPCOD  -->
        <div class="col-span-12 lg:col-span-6 mt-3 mb-5">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel htmlFor="horizontal-form-1" class="w-40 sw:w-20"
                >Código de empresa (brindado por Getnet)</FormLabel
              >
            </div>
            <div>
              <FormInput
                type="text"
                v-model.trim="formData.EmpCod"
                placeholder="Código"
              />
            </div>
          </div>
        </div>

        <hr />
        <p class="p-5">Configuración del Pos</p>
        <hr />
        <template v-for="(pos, index) in formData.integracionGetnetPOS">
          <OpcionesGeneralesGetnetPos
            :pos="pos"
            :indice="index"
            @actualizar="actualizarPOS"
          />
        </template>
        <Button
          variant="secondary"
          class="mb-2 mr-1 mt-5"
          @click="agregarPosVacio"
        >
          Agregar pos
        </Button>

        <div v-if="!cargando" class="flex mt-10">
          <div class="flex-1 text-left mt-3">
            <Button
              variant="secondary"
              class="mb-2 mr-1"
              @click="() => emit('cerrar')"
            >
              Cancelar
            </Button>
          </div>
          <div class="flex-1 text-right">
            <Button
              variant="primary"
              class="mb-2 mr-1 mt-3"
              @click="handlerGuardar"
            >
              Guardar
            </Button>
          </div>
        </div>
        <div v-else class="flex my-6">
          <div class="mx-auto">
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
      </div>
    </form>
  </Preview>
</template>
